import {useTranslation} from "react-i18next";
import styled, {useTheme} from "styled-components";
import React, {useCallback} from "react";
import {ImageLane} from "../common";
import {changePositionNameToImgPositionName} from "../../function";

const EventFilterWrapper = styled.div`
`;

const RegionBox = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const CategoryBox = styled.div`
  flex-wrap: wrap;
  gap: 16px;
  display: flex;
  flex-direction: row;
`;

const FilterButton = styled.button`
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.color.dark_300};
  display: flex;
  flex-direction: row;
  min-width: 96px;
  justify-content: center;
  align-items: center;
  height: 32px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  margin-inline: -1px;
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 6px;


  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }

  &.selected {
    border-color: ${props => props.selectedBorderColor || props.theme.color.green_100};
    background-color: ${props => props.selectedColor || props.theme.color.green_200};
    color: ${props => props.selectedFontColor || props.theme.color.green_100};
    font-weight: 700;
    z-index: 2;
  }
`;

const AllFilterButton = styled(FilterButton)`
  min-width: auto;
  padding: 0 10px;
`;
const ImageWrapper = styled.div`
  margin-right: 4px;
`

const Bar = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.color.gray_200};
  margin: 8px 0;
`;
const EventMangFilter = ({teamList, filterTeam, setFilterTeam, categorySelected, setCategorySelected}) => {

    const {t} = useTranslation();
    const theme = useTheme();
    const categoryList = [{
        title: '전체 팀', value: 'all'
    }, {
        title: '포지션 별 랭킹', value: 'role'
    }, {
        title: '8강 A조', value: 'A'
    }, {
        title: '8강 B조', value: 'B'
    }]

    const onClickCategorySelected = (value) => {
        setFilterTeam('');
        setCategorySelected(value)

    }


    if(!teamList){
        return null
    }


    return (
        <EventFilterWrapper>
            <CategoryBox>
                {categoryList.map((data, index) => {
                    return (
                        <CategoryItem data={data} key={index} selected={categorySelected === data.value}
                                      setSelected={onClickCategorySelected}/>
                    )
                })}
            </CategoryBox>
            <Bar/>
            <RegionBox>
                {/*<AllFilterButton className={filterTeam === 'all' ? 'selected' : ""}*/}
                {/*                 onClick={() => setFilterTeam('')}*/}
                {/*>{t('championAnalyze.all')}</AllFilterButton>*/}
                {/*{subjectList.map((data) => {*/}
                {/*    return (*/}
                {/*        <FilterButton className={subjectFilter === data ? 'selected' : ""}*/}
                {/*                      key={data}*/}
                {/*                      onClick={() => setSubjectFilter(data)}*/}
                {/*        >{data}</FilterButton>*/}
                {/*    )*/}
                {/*})}*/}
                {teamList.map((data, index) => {
                    return (
                        <TeamItem data={data} filterTeam={filterTeam} setFilterTeam={setFilterTeam} key={index}
                                  categorySelected={categorySelected}/>
                    )
                })}
            </RegionBox>
        </EventFilterWrapper>
    )
}


const TeamItem = ({filterTeam, data, setFilterTeam, categorySelected}) => {
    const theme = useTheme()
    const {t} = useTranslation()
    const getLaneName = useCallback((lane) => {
        switch (lane) {
            case 'Top':
                return t('gameAnalytics.top')
            case 'Jungle':
                return t('gameAnalytics.jungle')
            case 'Mid':
                return t('gameAnalytics.mid')
            case 'Bot':
                return t('championAnalyze.bot')
            case 'Support':
                return t('gameAnalytics.support')
            case 'Coach':
                return t('proStreamer.coach')
            default:
                break;
        }
    }, []);

    if (categorySelected === 'role') {
        return (
            <FilterButton className={filterTeam === data.team ? 'selected' : ""}
                          onClick={() => filterTeam === data.team ? setFilterTeam('') : setFilterTeam(data.team)}>
                <ImageWrapper>
                    <ImageLane
                        lane={changePositionNameToImgPositionName(data.team)}
                        color={theme.color.theme === 'dark' ? 'light' : 'dark'}
                    />
                </ImageWrapper>
                <span>{getLaneName(data.team)}</span>
            </FilterButton>
        )
    }


    return (
        <FilterButton className={filterTeam === data.team ? 'selected' : ""}
                      onClick={() => filterTeam === data.team ? setFilterTeam('') : setFilterTeam(data.team)}>
            <span>{data.team}</span>
        </FilterButton>
    )
}

const CategoryItemWrapper = styled.button`
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.color.dark_200};
  display: flex;
  flex-direction: row;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  height: 32px;

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }

  &.selected {
    background-color: ${props => props.theme.color.green_100};
    color: ${props => props.theme.color.site_main_color};
    font-weight: 700;
    z-index: 2;
  }
`;

const CategoryItem = ({selected, data, setSelected}) => {
    return (
        <CategoryItemWrapper className={selected ? 'selected' : ""} onClick={() => setSelected(data.value)}>
            {data.title}
        </CategoryItemWrapper>
    )
}
export default EventMangFilter